<div class="timeline">
  @for (sieste of getSiestes(); track $index) {
  <div class="timeline-item">
    <div class="timeline-dot"></div>
    <div class="timeline-content">
      <span class="time-badge secondary"><mat-icon>schedule</mat-icon>{{ sieste.input_heure | carnetHeure }}</span>
      @if (sieste.input_heureFin) {
      <mat-icon class="arrow-icon">arrow_forward</mat-icon>
      <span class="time-badge secondary"><mat-icon>schedule</mat-icon>{{ sieste.input_heureFin | carnetHeure }}</span>
      }
      @if (sieste.input_duree) {
      <span class="duration-badge">{{ sieste.input_duree | carnetDuree }}</span>
      }
      @if (sieste.input_observation) {
      <span class="muted">{{ sieste.input_observation }}</span>
      }
    </div>
  </div>
  }
  @if (getSiestes().length === 0) {
  <p class="no-data-section">Aucune sieste enregistrée.</p>
  }
</div>